module.exports = __webpack_public_path__ + "img/w3_trash_solid_light.748972da.png";